export default {
  SET_APPOINTMENT: '@@PO_ADMIN_RESERVATION/SET_APPOINTMENT',
  BOOK_APPOINTMENT: '@@PO_ADMIN_RESERVATION/BOOK_APPOINTMENT',
  SET_IS_LOADING: '@@PO_ADMIN_RESERVATION/SET_IS_LOADING',
};
